export * from './_internal/thread-list-member/threadListMemberGetters';
export * from './_internal/thread-list-member/threadListMemberSetters';
export * from './_internal/wasLastMessageSentByUser';
export * from './_internal/view-member-page/HelpDeskViewMembersPageResponseObject';
export * from './_internal/view-member-page/HelpDeskViewMembersSearchResponseObject';
export * from './_internal/view-member-page/HelpDeskViewMembersPage';
export * from './_internal/view-member-page/viewMembersPageGetters';

/**
 * @deprecated - use ViewOrderBy directly
 */

/**
 * @deprecated - rely on ViewOrderBy type and use string
 */
export const LATEST_MESSAGE = 'LATEST_MESSAGE';
/**
 * @deprecated - rely on ViewOrderBy type and use string
 */
export const LATEST_VISITOR_RESPONSE = 'LATEST_VISITOR_RESPONSE';
export { getConversationStatusFromThreadStatus } from './_internal/conversation-crm-object/conversationStatuses';
export { buildTlmFromViewMember } from './_internal/thread-list-member/buildTlmFromViewMember';
export { buildThreadListMember } from './_internal/thread-list-member/buildThreadListMember';
export { buildPartialThreadListMembers } from './_internal/thread-list-member/buildPartialThreadListMember';
export { isHelpDeskViewMember } from './_internal/view-member/isHelpDeskViewMember';
export { isInboxViewMember } from './_internal/view-member/isInboxViewMember';
export { isInboxThreadListMember } from './_internal/view-member/isInboxViewMember';
export { isThreadListMember } from './_internal/thread-list-member/isThreadListMember';
export { getViewMemberProps } from './_internal/view-member/getViewMemberProps';